import React from "react";

export const LosePodiumIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill="url(#paint0_linear_18326_100698)"
        fillOpacity="0.16"
      />
      <path
        d="M16.0013 7.66675C20.6036 7.66675 24.3346 11.3977 24.3346 16.0001C24.3346 17.3475 24.0148 18.6202 23.447 19.7466C23.3874 19.5147 23.2769 19.2937 23.1158 19.1006L23.0131 18.9882L21.8346 17.8097L20.6561 18.9882L20.5588 19.0942C20.0071 19.7491 20.0395 20.7287 20.6561 21.3452C21.013 21.7021 21.4913 21.8632 21.958 21.8289C20.4449 23.374 18.3351 24.3334 16.0013 24.3334C11.3989 24.3334 7.66797 20.6024 7.66797 16.0001C7.66797 11.3977 11.3989 7.66675 16.0013 7.66675ZM16.0013 18.5001C14.8512 18.5001 13.8099 18.9661 13.056 19.7195L12.918 19.8641L13.7055 20.5802C14.3638 20.3188 15.153 20.1667 16.0013 20.1667C16.7554 20.1667 17.4627 20.2869 18.0729 20.4972L18.2971 20.5802L19.0846 19.8641C18.3224 19.0261 17.2233 18.5001 16.0013 18.5001ZM13.0846 14.3334C12.3943 14.3334 11.8346 14.8931 11.8346 15.5834C11.8346 16.2737 12.3943 16.8334 13.0846 16.8334C13.775 16.8334 14.3346 16.2737 14.3346 15.5834C14.3346 14.8931 13.775 14.3334 13.0846 14.3334ZM18.918 14.3334C18.2276 14.3334 17.668 14.8931 17.668 15.5834C17.668 16.2737 18.2276 16.8334 18.918 16.8334C19.6083 16.8334 20.168 16.2737 20.168 15.5834C20.168 14.8931 19.6083 14.3334 18.918 14.3334Z"
        fill="#FE4949"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18326_100698"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};
